import React, { useEffect, useRef, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./HeaderFigma.css";
import {
  AccountCircle,
  AddShoppingCart,
  FavoriteBorder,
  Menu,
  Search,
} from "@mui/icons-material";
// import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { Offcanvas } from "bootstrap";
import LanguageSwitcher from "../Home/LanguageSwitcher";
import NavbarWithDropdown from "./NavbarWithDropdown";
import MobileLinks from "./MobileLinks";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/features/loginSlice";
import LoginModal from "../../modal/LoginModal";
import RegisterModal from "../../modal/RegisterModal";
import ForgotPasswordModal from "../../modal/ForgotPasswordModal";
import VerifyOtpModal from "../../modal/VerifyOtpModal";
import ResetPasswordModal from "../../modal/ResetPasswordModal";
import NavbarTopLinks from "./NavbarTopLinks";
import { clearSuggestions, fetchProductSuggestions, fetchSearchResults, resetSearch } from "../../redux/features/searchProductsSlice";
import { useUrlChange } from "../../hooks/useUrlChange";
import LanguageSwitcherNew from "../Home/LanguageSwitcherNew";
import SearchBar from "./SearchBar";
import { useModal } from "../../hooks/ModalContext";
import TransparentLogo from '../../assets/img/tranLogo1024.png'

const HeaderFigma = ({ productListRef, setIsSearching }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const [isSticky, setIsSticky] = useState(false);
  const [openedDrawer, setOpenedDrawer] = useState(false);
  const [isLoginFlow, setIsLoginFlow] = useState(false);

  //old Topbar states for search and filter
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);
  const [selectedDeliveryDays, setSelectedDeliveryDays] = useState(null);
  const [minPrice, setMinPrice] = useState(null);
  const [maxPrice, setMaxPrice] = useState(null);
  const [selectedSort, setSelectedSort] = useState(null);
  // const [searchTerm, setSearchTerm] = useState("");

  //models flow
  const { activeModal, setActiveModal, emailForOtp, setEmailForOtp } = useModal();

  const drawerRef = useRef(null);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { api_token, emailVerify } = useSelector((state) => state.auth);
  const { emailForOtp: emailForOtpLogin } = useSelector((state) => state.auth);
  const { emailForOtp: emailForOtpRegister } = useSelector(
    (state) => state.register
  );
  const lang = useSelector((state) => state.language.lang);
  const { suggestions, showSuggestions } = useSelector(
    (state) => state.search
  );

  // --- Static data instead of contexts ---
  const isLoggedIn = false; // change to true to test profile state
  const userProfile = {
    profileImageUrl: "https://via.placeholder.com/40", // test avatar
  };
  const cartCount = useSelector((state) => state.cartcount.cartcount) || 0;
  const wishlistCount = useSelector((state) => state.wishlist.likedItems?.length) || 0;
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    const offcanvasElement = document.getElementById("mobileMenu");
    if (offcanvasElement) {
      new Offcanvas(offcanvasElement); // Initialize it once
    }
  }, []);

  // Sticky Navbar
  useEffect(() => {
    const handleScroll = () => setIsSticky(window.scrollY > 150);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Clear search on page change
  // useEffect(() => {
  //   setSearchQuery("");
  //   dispatch(resetSearch());

  //   const params = new URLSearchParams(window.location.search);
  //   params.delete("query");
  //   navigate({
  //     pathname: location.pathname,
  //     search: params.toString() ? `?${params.toString()}` : "",
  //   }, { replace: true });
  // }, [location.pathname, navigate, dispatch]);

  useEffect(() => {
    if (location.pathname === "/") {
      setSearchQuery("");
      dispatch(resetSearch());
    }
  }, [location.pathname, dispatch]);

  useUrlChange(() => {
    const params = new URLSearchParams(window.location.search);
    const parentCat = params.get("parent_category_id");
    const childCat = params.get("category_id");

    if (parentCat || childCat) {
      setSearchQuery("");
      dispatch(resetSearch());
    }
  });

  // Drawer toggle

  const toggleDrawer = () => setOpenedDrawer(!openedDrawer);
  const handleClickOutside = useCallback((event) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      setOpenedDrawer(false);
    }
  }, []);

  useEffect(() => {
    if (openedDrawer) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openedDrawer, handleClickOutside]);

  // Navigation for mobile links
  const handleNavigation = (path) => {
    const offcanvasElement = document.getElementById("mobileMenu");
    if (offcanvasElement) {
      const bsOffcanvas = Offcanvas.getInstance(offcanvasElement);
      bsOffcanvas?.hide();
    }
    navigate(path);
  };

  const handleSearchSubmit = (e) => {
    if (e?.preventDefault) e.preventDefault();
    if (!searchQuery.trim()) return;

    // 🔥 CLEAR SUGGESTIONS ALWAYS ON SUBMIT
    dispatch(clearSuggestions());

    const normalizedSearchTerm = searchQuery.trim().replace(/\s+/g, " ");
    const newParams = new URLSearchParams();

    newParams.set("query", normalizedSearchTerm);

    // ✅ Remove filters during search
    newParams.delete("parent_category_id");
    newParams.delete("category_id");

    const currentPath = location.pathname;

    // ✅ If user is NOT on home or shops page, redirect to /shops
    if (currentPath !== "/" && currentPath !== "/shops") {
      navigate({
        pathname: `/shops`,
        search: `?${newParams.toString()}`,
      }, { replace: true });
    } else {
      // ✅ Stay on current page (/, /shops)
      navigate({
        pathname: currentPath,
        search: `?${newParams.toString()}`,
      }, { replace: true });
    }

    productListRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleLogout = () => {
    dispatch(logout());
    setActiveModal(null);
    setEmailForOtp("");
  };

  const forgotPasswordClick = () => {
    setIsLoginFlow(true);
  };

  return (
    <>
      <header className="bg-white px-0">
        <nav
          className={`p-2 navbar-expand-lg navbar-light bg-white border-bottom ${isSticky ? "sticky-navbar" : ""
            }`}
        >
          <div className="container px-0">
            {/* Desktop */}
            <div className="row align-items-center d-lg-flex d-md-none d-none">
              <div className="col-7 d-flex align-items-center">
                <ul className="nav w-100 justify-content-between align-items-center text-figma-green">
                  <div className="site-branding flex-shrink-0">
                    <a href="/" className="brand-logo">
                      <h3 className="m-0">Amzio</h3>
                      <img
                        src={TransparentLogo}
                        alt="Amzio Logo"
                      />
                    </a>
                  </div>

                  <div className="flex-grow-1 d-flex justify-content-end" style={{ minWidth: 0 }}>
                    <NavbarTopLinks />
                  </div>

                </ul>
              </div>

              {/* Search */}
              <div className="col-3">
                <div className="position-relative d-flex justify-content-start">
                  <SearchBar
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onSubmit={handleSearchSubmit}
                    debounceMs={300}
                    onDebouncedChange={(value) => {
                      if (!value.trim()) {
                        dispatch(clearSuggestions());
                        return;
                      }
                      if (window.innerWidth >= 992) {
                        dispatch(fetchProductSuggestions({ search: value, lang }));
                      }
                    }}
                    onBlur={() => dispatch(clearSuggestions())}
                    placeholder={t("Search")}
                  />
                  {suggestions?.length > 0 && (
                    <div className="suggestion-card shadow-sm p-3 position-absolute"
                      style={{
                        top: "50px",
                        left: 0,
                        width: "100%",
                        background: "#fff",
                        borderRadius: "0 0 10px 10px",
                        zIndex: 1000,
                        maxHeight: "300px",
                        overflowY: "auto",
                      }}
                    >
                      {suggestions.map((item) => (
                        <div
                          key={item.id}
                          className="py-2 px-1 suggestion-item"
                          onClick={() => {
                            const cleanText = item.suggest.replace(/<[^>]+>/g, "");

                            setSearchQuery(cleanText);
                            dispatch(clearSuggestions());
                            navigate(
                              `/shops?query=${encodeURIComponent(cleanText)}&category_id=${encodeURIComponent(item.id)}`
                            );
                          }}

                          style={{
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          dangerouslySetInnerHTML={{ __html: item.suggest }}
                        ></div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* Icons */}
              <div className="col-2 d-flex align-items-center justify-content-between px-0 gap-2">
                {/* Liked */}
                <div className="position-relative">
                  <div
                    className="text-decoration-none ps-2"
                    style={{ color: "var(--secondary-light-color)", cursor: "pointer" }}
                    role="button"
                    aria-label="Open wishlist"
                    onClick={() => {
                      if (api_token) {
                        navigate("/wishlist");
                      } else {
                        setActiveModal("login");
                      }
                    }}
                  >
                    <FavoriteBorder size={30} />
                  </div>
                  {/* <span className="badge rounded-pill bg-green-theme position-absolute top-0 end-0 translate-middle" aria-label={`Wishlist items: ${wishlistCount}`}>
                    {wishlistCount}
                  </span> */}
                </div>

                {/* Cart */}
                <div className="position-relative">
                  <div
                    className="text-decoration-none ps-2"
                    style={{ color: "var(--secondary-light-color)", cursor: "pointer" }}
                    role="button"
                    aria-label="Open cart"
                    onClick={() => {
                      if (api_token) {
                        navigate("/cart");
                      } else {
                        setActiveModal("login");
                      }
                    }}
                  >
                    <AddShoppingCart size={30} />
                  </div>

                  {/* <span className="badge rounded-pill bg-green-theme position-absolute top-0 end-0 translate-middle" aria-label={`Cart items: ${cartCount}`}>
                    {cartCount}
                  </span> */}
                </div>

                <div className="position-relative">
                  <LanguageSwitcher />
                </div>

                {/* Profile */}
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle d-flex align-items-center justify-content-center px-1"
                    type="button"
                    id="profileDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ color: 'var(--secondary-light-color)' }}
                    aria-label="Open profile menu"
                  >
                    <AccountCircle sx={{ color: "var(--secondary-light-color)" }} />
                  </button>

                  <ul
                    className="dropdown-menu dropdown-menu-end shadow-sm mt-3 p-0"
                    aria-labelledby="profileDropdown"
                    style={{
                      backgroundColor: "white",
                      color: "var(--secondary-light-color)",
                      borderRadius: 0
                    }}
                  >
                    {api_token ? (
                      <>
                        <li>
                          <Link
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            to="/dashboard"
                          >
                            <i className="fas fa-user me-2"></i>
                            {t("Profile")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/about-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-info-circle me-2"></i> {t("About_Us")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/contact-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-envelope me-2"></i> {t("Contact_Us")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/faqs" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-question-circle me-2"></i> {t("FAQS")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/terms&condition" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-file-contract me-2"></i> {t("Terms_Conditions")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/refund-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-undo me-2"></i> {t("Refund_Policy")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/return-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-exchange-alt me-2"></i> {t("Return_Policy")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/ask-a-questions" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-headset me-2"></i> {t("Support_Center")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/order" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-truck me-2"></i> {t("Tracking_Orders")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/happy-customers" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-smile-beam me-2"></i> {t("Happy_Customers")}
                          </Link>
                        </li>

                        <li>
                          <button
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            onClick={handleLogout}
                          >
                            <i className="fas fa-sign-out-alt me-2"></i> {t("Logout")}
                          </button>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <button
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            onClick={() => setActiveModal("login")}
                          >
                            <i className="fas fa-sign-in-alt me-2"></i> {t("Login")}
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            onClick={() => setActiveModal("register")}
                          >
                            <i className="fas fa-user-plus me-2"></i> {t("Register")}
                          </button>
                        </li>

                        {/* <li>
                          <Link to="/about-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-info-circle me-2"></i> About Us
                          </Link>
                        </li>

                        <li>
                          <Link to="/contact-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-envelope me-2"></i> Contact Us
                          </Link>
                        </li>

                        <li>
                          <Link to="/faqs" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-question-circle me-2"></i> FAQs
                          </Link>
                        </li>

                        <li>
                          <Link to="/terms&condition" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-file-contract me-2"></i> Terms & Conditions
                          </Link>
                        </li>

                        <li>
                          <Link to="/refund-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-undo me-2"></i> Refund Policy
                          </Link>
                        </li>

                        <li>
                          <Link to="/return-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-exchange-alt me-2"></i> Return Policy
                          </Link>
                        </li>

                        <li>
                          <Link to="/ask-a-questions" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-headset me-2"></i> Support Center
                          </Link>
                        </li>

                        <li>
                          <Link to="/order" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-truck me-2"></i> Tracking Orders
                          </Link>
                        </li>

                        <li>
                          <Link to="/happy-customers" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-smile-beam me-2"></i> Happy Customers
                          </Link>
                        </li> */}

                        {/* <li>
                          <a href="#" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-balance-scale me-2"></i> Bails
                          </a>
                        </li> */}
                      </>
                    )}
                  </ul>
                </div>

              </div>
            </div>

            {/* Mobile */}
            <div className="row d-lg-none d-flex px-2 align-items-center justify-content-between">
              <div className="col-6">
                <div className="site-branding flex-shrink-0">
                  <a href="/" className="brand-logo">
                    <h3 className="m-0">Amzio</h3>
                    <img
                      src={TransparentLogo}
                      alt="Amzio Logo"
                    />
                  </a>
                </div>
              </div>
              <div className="col-6 d-flex justify-content-end align-items-center">
                {/* Liked */}
                <div className="position-relative mx-2">
                  <div
                    className="text-decoration-none ps-2"
                    style={{ color: "var(--secondary-light-color)", cursor: "pointer" }}
                    role="button"
                    aria-label="Open wishlist"
                    onClick={() => {
                      if (api_token) {
                        navigate("/wishlist");
                      } else {
                        setActiveModal("login");
                      }
                    }}
                  >
                    <FavoriteBorder size={30} />
                  </div>
                  {/* <span className="badge rounded-pill bg-green-theme position-absolute top-0 end-0 translate-middle" aria-label={`Wishlist items: ${wishlistCount}`}>
                    {wishlistCount}
                  </span> */}
                </div>

                {/* Cart */}
                <div className="position-relative mx-2">
                  <div
                    className="text-decoration-none ps-2"
                    style={{ color: "var(--secondary-light-color)", cursor: "pointer" }}
                    role="button"
                    aria-label="Open cart"
                    onClick={() => {
                      if (api_token) {
                        navigate("/cart");
                      } else {
                        setActiveModal("login");
                      }
                    }}
                  >
                    <AddShoppingCart size={30} />
                  </div>
                  {/* <span className="badge rounded-pill bg-green-theme position-absolute top-0 end-0 translate-middle" aria-label={`Cart items: ${cartCount}`}>
                    {cartCount}
                  </span> */}
                </div>

                {/* Language Switcher */}
                {/* <div className="position-relative">
                  <LanguageSwitcher />
                </div> */}

                {/* Profile */}
                <div className="dropdown">
                  <button
                    className="btn dropdown-toggle d-flex align-items-center justify-content-center px-1"
                    type="button"
                    id="profileDropdown"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    style={{ color: 'var(--secondary-light-color)' }}
                    aria-label="Open profile menu"
                  >
                    <AccountCircle sx={{ fontSize: 28, color: "var(--secondary-light-color)" }} />
                  </button>

                  <ul
                    className="dropdown-menu dropdown-menu-end shadow-sm mt-3 p-0"
                    aria-labelledby="profileDropdown"
                    style={{
                      backgroundColor: "white",
                      color: "var(--secondary-light-color)",
                    }}
                  >
                    {api_token ? (
                      <>
                        <li>
                          <Link
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            to="/dashboard"
                          >
                            <i className="fas fa-user me-2"></i> {t("Profile")}
                          </Link>
                        </li>
                        <li>
                          <Link to="/about-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-info-circle me-2"></i> {t("About_Us")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/contact-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-envelope me-2"></i> {t("Contact_Us")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/faqs" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-question-circle me-2"></i> {t("FAQS")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/terms&condition" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-file-contract me-2"></i> {t("Terms_Conditions")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/refund-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-undo me-2"></i> {t("Refund_Policy")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/return-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-exchange-alt me-2"></i> {t("Return_Policy")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/ask-a-questions" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-headset me-2"></i> {t("Support_Center")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/order" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-truck me-2"></i> {t("Tracking_Orders")}
                          </Link>
                        </li>

                        <li>
                          <Link to="/happy-customers" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-smile-beam me-2"></i> {t("Happy_Customers")}
                          </Link>
                        </li>

                        <li
                          className="dropdown-item p-0 px-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <LanguageSwitcherNew />
                        </li>

                        <li>
                          <button
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            onClick={handleLogout}
                          >
                            <i className="fas fa-sign-out-alt me-2"></i> {t("Logout")}
                          </button>
                        </li>
                      </>
                    ) : (
                      <>
                        <li>
                          <button
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            onClick={() => setActiveModal("login")}
                          >
                            <i className="fas fa-sign-in-alt me-2"></i> {t("Login")}
                          </button>
                        </li>
                        <li>
                          <button
                            className="dropdown-hover-custom dropdown-item d-flex align-items-center"
                            onClick={() => setActiveModal("register")}
                          >
                            <i className="fas fa-user-plus me-2"></i> {t("Register")}
                          </button>
                        </li>

                        <li
                          className="dropdown-item p-0 px-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <LanguageSwitcherNew />
                        </li>

                        {/* <li>
                          <Link to="/about-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-info-circle me-2"></i> About Us
                          </Link>
                        </li>

                        <li>
                          <Link to="/contact-us" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-envelope me-2"></i> Contact Us
                          </Link>
                        </li>

                        <li>
                          <Link to="/faqs" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-question-circle me-2"></i> FAQs
                          </Link>
                        </li>

                        <li>
                          <Link to="/terms&condition" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-file-contract me-2"></i> Terms & Conditions
                          </Link>
                        </li>

                        <li>
                          <Link to="/refund-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-undo me-2"></i> Refund Policy
                          </Link>
                        </li>

                        <li>
                          <Link to="/return-policies" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-exchange-alt me-2"></i> Return Policy
                          </Link>
                        </li>

                        <li>
                          <Link to="/ask-a-questions" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-headset me-2"></i> Support Center
                          </Link>
                        </li>

                        <li>
                          <Link to="/order" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-truck me-2"></i> Tracking Orders
                          </Link>
                        </li>

                        <li>
                          <Link to="/happy-customers" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-smile-beam me-2"></i> Happy Customers
                          </Link>
                        </li>

                        <li
                          className="dropdown-item p-0 ps-2"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <LanguageSwitcherNew />
                        </li> */}

                        {/* <li>
                          <a href="#" className="dropdown-hover-custom dropdown-item d-flex align-items-center">
                            <i className="fas fa-balance-scale me-2"></i> Bails
                          </a>
                        </li> */}
                      </>
                    )}
                  </ul>
                </div>

                {/*<button
                  className="btn btn-light border-0 bg-transparent"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#mobileMenu"
                >
                  <Menu fontSize="small" style={{ color: "var(--secondary-light-color)" }} />
                </button>*/}

                {/* <div className="offcanvas offcanvas-start" tabIndex="-1" id="mobileMenu">
                  <div className="offcanvas-header">
                    <button type="button" className="btn-close" data-bs-dismiss="offcanvas"></button>
                  </div>
                  <div className="offcanvas-body py-0">
                    <ul className="nav flex-column text-figma-green">
                      <NavbarTopLinks />
                      <li className="nav-item">
                        <a className="nav-link fw-bold" onClick={() => handleNavigation("/about-us")}>
                          About Us
                        </a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link fw-bold" onClick={() => handleNavigation("/contact-us")}>
                          Contact Us
                        </a>
                      </li>
                      <div className="nav-item px-3">
                        <LanguageSwitcher />
                      </div>
                    </ul>
                  </div>
                </div> */}

              </div>
            </div>

            {/* Mobile Search */}
            <div className="row d-lg-none px-2 mt-2">
              <div className="col-12">
                <div className="position-relative d-flex justify-content-start">
                  <SearchBar
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onSubmit={handleSearchSubmit}
                    debounceMs={300}
                    onDebouncedChange={(value) => {
                      if (!value.trim()) {
                        dispatch(clearSuggestions());
                        return;
                      }
                      if (window.innerWidth < 992) {
                        dispatch(fetchProductSuggestions({ search: value, lang }));
                      }
                    }}
                    onBlur={() => dispatch(clearSuggestions())}
                    placeholder={t("Search")}
                  />
                  {suggestions?.length > 0 && (
                    <div className="suggestion-card shadow-sm p-3 position-absolute"
                      style={{
                        top: "50px",
                        left: 0,
                        width: "100%",
                        background: "#fff",
                        borderRadius: "0 0 10px 10px",
                        zIndex: 1000,
                        maxHeight: "300px",
                        overflowY: "auto",
                      }}
                    >
                      {suggestions.map((item) => (
                        <div
                          key={item.id}
                          className="py-2 px-1 suggestion-item"
                          onClick={() => {
                            const cleanText = item.suggest.replace(/<[^>]+>/g, "");
                            setSearchQuery(cleanText);
                            dispatch(clearSuggestions());
                            navigate(
                              `/shops?query=${encodeURIComponent(cleanText)}&category_id=${encodeURIComponent(item.id)}`
                            );
                          }}
                          style={{
                            cursor: "pointer",
                            borderBottom: "1px solid #eee",
                          }}
                          dangerouslySetInnerHTML={{ __html: item.suggest }}
                        ></div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default HeaderFigma;
